import { render, staticRenderFns } from "./WizardHeaderStep.vue?vue&type=template&id=e353c184&"
import script from "./WizardHeaderStep.vue?vue&type=script&lang=js&"
export * from "./WizardHeaderStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports